import {configureStore} from '@reduxjs/toolkit';
import counterReducer from './features/counterSlice';
import nftReducer from './features/nftSlice';
export const store = configureStore({
  reducer: {
    counter: counterReducer,
    nft: nftReducer
  }
});
